
import {environment} from '../../../../../environments/environment';
import {Injectable} from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';

@Injectable()

export class FlightInfoService {
  route = 'flights/info/';
  constructor(private http: AuthHttp) {}

  getFlightInfo(id: number) {
    return this.http.get(`${environment.baseUrl}${this.route}${id}`).map(res => res.json()).toPromise();

  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/dashboard/services/flight/flight-info-service.ts